import React from "react";
import Icon from "../AppIcon"; // adjust path if different

const PageLoader = () => {
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-background/95 backdrop-blur-sm">
      <div className="animate-spin-slow">
        <Icon
          name="Settings"
          size={70}
          color="var(--color-accent)"
          strokeWidth={1}
        />
      </div>
      <p className="mt-4 text-gray-400 text-sm font-medium uppercase tracking-widest">
        Loading...
      </p>
    </div>
  );
};

export default PageLoader;
